const standaloneAuthRoutes = [
  '/admin/login',
  '/login',
  '/signup',
  '/forgot-password',
  '/reset-password'
];

export const isAuthRoute = (pathname) =>
  standaloneAuthRoutes.includes(pathname) || /^\/[^/]+\/(login|signup)$/.test(pathname);
